import { ErrorBoundary } from '@sentry/react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ErrorMsg } from '../../../components/AppMessages';
import { InAppMultiSelectFilter } from '../../../components/Filters/common/InAppMultiselectFilter';
import { ALL_OPTION_NO_SPACE } from '../../../constants';
import { closeFilterOptions } from '../../../components/Filters/subs/helpers';
import { setSpecificParameter } from '../../../actions';
import { getDomainList } from '../../../api/geoReportingApi';



const DomainFilters = withRouter((props: RouteComponentProps) => {

    const { history } = props;
    const dispatch = useDispatch();

    const searchWithoutDomain = React.useMemo(() => {
        const params = new URLSearchParams(history.location.search);
        params.delete("domain");
        params.delete("funnel")
        return params.toString();
    }, [history.location.search]);

    const { data, isFetching, refetch } = useQuery({
        queryKey: ["domainFilters", searchWithoutDomain],
        queryFn: () => getDomainList(),
        enabled: false,
    });

    React.useEffect(() => {
        const urlDateRange = new URLSearchParams(history.location.search).get("date_range");
        if (urlDateRange) refetch();
    }, [searchWithoutDomain]);

    const [domainFilterValue, setDomainFilterValue] = useState(ALL_OPTION_NO_SPACE);

    const handleDomainMultiselectSubmit = useCallback(() => {
        const selectedValues: string[] = [];
        document.querySelectorAll<HTMLInputElement>(
            `[type="checkbox"][data-filter-name="domain_param"][data-options-type="single"]:checked`
        ).forEach((cb) => selectedValues.push(cb.value));

        const filterValue = data?.length === selectedValues.length ? "All" : selectedValues.join(",");
        closeFilterOptions();
        setDomainFilterValue(filterValue);
        dispatch(setSpecificParameter("domain_param", filterValue));
    }, [data, dispatch]);

    React.useEffect(() => {
        const params = new URLSearchParams(history.location.search);
        params.set("domain", domainFilterValue);
        history.push({ search: `?${params.toString()}` });
    }, [domainFilterValue]);

    return (
        <div>
            <div className="row grid">
                <div className=" h-30 grid-col-span-6 verbatimTile">
                    <div className="space-between verbatim-tile-header">

                        <div className="flex-row">
                            <ErrorBoundary fallback={<ErrorMsg />}>
                                <InAppMultiSelectFilter
                                    filterLabel="Domain"
                                    optionsList={data ?? []}
                                    filterValue={domainFilterValue}
                                    parameterName="domain_param"
                                    parameterValue={domainFilterValue}
                                    maxSelectable={10}
                                    handleFilterSubmission={handleDomainMultiselectSubmit}
                                />
                            </ErrorBoundary>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
});

export default DomainFilters;